import React, { useState, useEffect } from 'react';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, Link } from 'react-router-dom';
import { Table, Modal, Button, Form, ProgressBar, DropdownButton } from 'react-bootstrap';
import { FaArrowLeft, FaArrowRight, FaChartLine, FaFileImport, FaRegPlayCircle, FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa';
import useAuth from '../../dashboard/useAuth';
import { ReactTags } from 'react-tag-autocomplete'
import Select from "react-select";
import axios from 'axios';
import { HexColorPicker } from "react-colorful";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';



const Configuration_parcours = ({ titre }) => {
    useAuth();
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const location = useLocation();
    const { parcours_id } = location.state || {};
    const { parcours_titre } = location.state || {};
    const user_id = localStorage.getItem('user_id');
    const [selectedEtape, setSelectedEtape] = useState(null);
    const [configurationdModal, setConfigurationdModal] = useState(false);
    const [modifEtapeModal, setModifEtapeModal] = useState(false);
    const [confirmerModifEtapeModal, setConfirmerModifEtapeModal] = useState(false);
    const [confirmerSuppressionEtapeModal, setConfirmerSuppressionEtapeModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [listeEtape, setListeEtape] = useState([]);
    const [tags, setTags] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);
    const [isLoadingModification, setIsLoadingModification] = useState(false);
    const [isLoadingAjout, setIsLoadingAjout] = useState(false);
    const [etape, setEtape] = useState({});

    const handleShowImportModal = () => {
        setShowImportModal(true);
    };
    const handleCloseImportModal = () => {
        setShowImportModal(false);
    };
    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]); // Met à jour l'état du fichier sélectionné
    };


    const [notifications, setNotifications] = useState([]);
    const fetchNotifications = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-notifications/');
            if (response.ok) {
                const data = await response.json();
                setNotifications(data);
            } else {
                console.error('Erreur lors de la récupération des notifications');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };



    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(listeEtape);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        // Mettre à jour les numéros d'ordre en fonction de la nouvelle position
        const updatedItems = items.map((item, index) => ({
            ...item,
            numero: index + 1
        }));

        setListeEtape(updatedItems);

        // Envoyer les nouvelles positions au serveur
        updateEtapeOrder(updatedItems);
    };

    const updateEtapeOrder = async (updatedItems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/reordonner-etapes/`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    etapes: updatedItems,
                    user_id: user_id
                }),
            });

            if (!response.ok) {
                console.error("Erreur lors de la mise à jour de l'ordre des étapes");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
        }
    };




    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        fetchEtapeData()
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };


    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        fetchEtapeData()
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 10000);
    };

    const fetchEtapeData = async () => {
        setIsLoadingGlobale(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-etape/${parcours_id}/`);
            const data = await response.json();
            if (response.ok) {
                setListeEtape(data.etape);
            } else {
                console.error('Erreur lors de la récupération des données du parcours. Code:', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingGlobale(false)
        }
    };

    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
                if (response.ok) {
                    const data = await response.json();
                    setTags(data);
                } else {
                    console.error('Erreur lors de la récupération des tags');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchTags();
    }, []);

    useEffect(() => {
        fetchEtapeData();
        fetchNotifications();
    }, []);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser la page actuelle
    };

    // Filtrage par recherche 
    const filteredEtapes = listeEtape.filter(etape =>
        etape.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.module.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const indexOfLastEtape = currentPage * itemsPerPage;
    const indexOfFirstEtape = indexOfLastEtape - itemsPerPage;
    const currentEtape = filteredEtapes.slice(indexOfFirstEtape, indexOfLastEtape); // Appliquer la pagination ici

    const totalPages = Math.ceil(filteredEtapes.length / itemsPerPage);


    const handleConfigurationdModal = () => setConfigurationdModal(true);
    const handleFermerConfigurationModal = () => setConfigurationdModal(false);

    const handleModifEtapeModal = () => setModifEtapeModal(true);
    const handleFermerModifEtapeModal = () => setModifEtapeModal(false);

    const handleConfirmerModifEtapeModal = () => setConfirmerModifEtapeModal(true);
    const handleFermerConfirmerModifEtapeModal = () => setConfirmerModifEtapeModal(false);

    const handleConfirmerSuppressionEtapeModal = () => setConfirmerSuppressionEtapeModal(true);
    const handleFermerConfirmerSuppressionEtapeModal = () => setConfirmerSuppressionEtapeModal(false);

    const handleEnregEtape = async () => {
        // Vérification des champs vides
        if (!etape.titre || !etape.date_echeance || !etape.module) {
            showAlertModal('Tous les champs doivent être remplis.', 'danger');
            return;
        }

        // Gestion du numéro de l'étape
        if (!etape.numero) {
            etape.numero = listeEtape && listeEtape.length > 0
                ? Math.max(...(listeEtape.map(e => e.numero) || [0])) + 1
                : 1; // Si la liste est vide, assigne numéro à 1
        }

        if (etape.numero <= 0) {
            showAlertModal('L\'ordre doit être supérieur à 0.', 'danger');
            return;
        }

        if (listeEtape.some(etapeExistante => etapeExistante.numero === Number(etape.numero))) {
            showAlertModal('Le numéro choisi est déjà utilisé. Veuillez en choisir un autre.', 'danger');
            return;
        }

        if ((etape.module === 'Evaluation') && etape.tags.length === 0) {
            showAlertModal('Les tags sont obligatoires pour le module "évaluation".', 'danger');
            return;
        }

        if (etape.module === 'Autre') {
            etape.module = etape.autre
        }

        const validateUrl = (url) => {
            if (!url) return true; // Vide est acceptable
            return url.startsWith('http://') || url.startsWith('https://');
        };

        if (etape.lien_url && !validateUrl(etape.lien_url)) {
            showAlertModal('L\'URL doit commencer par http:// ou https://', 'danger');
            return;
        }

        // Vérification de la date par rapport à l'étape précédente
        // const sortedEtapes = [...listeEtape].sort((a, b) => a.numero - b.numero); // Trier les étapes par numéro
        // const etapePrecedente = sortedEtapes.find(e => e.numero === Number(etape.numero) - 1);

        // if (etapePrecedente) {
        //     const [dayPrev, monthPrev, yearPrev] = etapePrecedente.date_echeance.split('/'); // Date précédente (DD/MM/YYYY)
        //     const datePrecedente = new Date(`${yearPrev}-${monthPrev}-${dayPrev}`); // Convertir au format ISO

        //     const [dayCur, monthCur, yearCur] = etape.date_echeance.split('/'); // Date actuelle (DD/MM/YYYY)
        //     const dateActuelle = new Date(`${yearCur}-${monthCur}-${dayCur}`); // Convertir au format ISO

        //     if (dateActuelle < datePrecedente) {
        //         showAlertModal('La date de l\'étape ne peut pas être antérieure à la date de l\'étape précédente.', 'danger');
        //         return;
        //     }
        // }

        setIsLoadingAjout(true)
        try {
            // Ajouter l'étape
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-etape/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...etape,
                    parcours_id: parcours_id,
                }),
            });

            if (response.ok) {
                showAlert('Étape ajoutée avec succès !');
                handleFermerConfigurationModal();
                fetchEtapeData();
                setEtape({ titre: '', coach: '', date_echeance: '', module: '', tags: [], numero: '', fichier: '' });

            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData.error);
                showAlertModal('Erreur lors de l’ajout de l’étape : ' + (errorData.message || 'Erreur inconnue.'), 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur. Veuillez réessayer plus tard.');
        } finally {
            setIsLoadingAjout(false)
        }
    };


    const getTextColor = (bgColor) => {
        if (!bgColor || bgColor === 'transparent') return 'inherit'; // Couleur par défaut

        // Convertit la couleur hex en RGB
        const hexToRgb = (hex) => {
            const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? [
                parseInt(result[1], 16),
                parseInt(result[2], 16),
                parseInt(result[3], 16)
            ] : [0, 0, 0];
        };

        const [r, g, b] = hexToRgb(bgColor);

        // Calcule la luminance (formule de perception humaine)
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        // Retourne noir ou blanc selon la luminance
        return luminance > 0.5 ? '#000000' : '#FFFFFF';
    };


    const handleEnregModifEtapePartout = async () => {
        // Vérification des champs vides
        if (!selectedEtape.titre || !selectedEtape.date_echeance || !selectedEtape.module || !selectedEtape.numero) {
            showAlertModal('Tous les champs doivent être remplis.', 'danger');
            return;
        }

        if (selectedEtape.numero <= 0) {
            showAlertModal('L\'ordre doit être supérieur à 0.', 'danger');
            return;
        }

        if (listeEtape.some(etapeExistante =>
            etapeExistante.numero === Number(selectedEtape.numero) &&
            etapeExistante.id !== selectedEtape.id // Vérifie si l'ID est différent
        )) {
            showAlertModal('Le numéro choisi est déjà utilisé. Veuillez en choisir un autre.', 'danger');
            return;
        }

        if ((selectedEtape.module === 'Evaluation') && selectedEtape.tags.length === 0) {
            showAlertModal('Les tags sont obligatoires pour le module "évaluation".', 'danger');
            return;
        }

        if (selectedEtape.module === 'Autre') {
            selectedEtape.module = selectedEtape.autre
        }

        setIsLoadingModification(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-etapes-pour-utilisateurs/${user_id}/`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(selectedEtape),
            });
            const data = await response.json();

            if (response.ok) {
                showAlert("Modifications enregistrées avec succès !");
                setConfirmerModifEtapeModal(false);
                setModifEtapeModal(false);
                // setSelectedEtape(null);
                setSelectedEtape(data.etape || selectedEtape);
            } else {
                console.error("Erreur lors de l'enregistrement des modifications.", data);
                showAlertModal("Erreur lors de l'enregistrement des modifications.");
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        } finally {
            setIsLoadingModification(false)
        }
    };

    // const handleSupprimerEtape = async () => {
    //     if (selectedEtape) {
    //         try {
    //             const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-etape/${selectedEtape.id}/`, {
    //                 method: 'DELETE',
    //             });
    //             const data = await response.json();

    //             if (response.ok) {
    //                 // setEtape(etape.filter((etape) => etape.id !== selectedEtape.id));
    //                 fetchEtapeData()
    //                 setSelectedEtape(null);
    //                 setConfirmerSuppressionEtapeModal(false);
    //                 showAlert("Etape supprimé avec succès !");
    //             } else {
    //                 console.error('Erreur lors de la suppression de l\'etape', data);
    //             }
    //         } catch (error) {
    //             console.error('Erreur réseau:', error);
    //         }
    //     }
    // };


    const handleSupprimerEtapePartout = async () => {
        if (selectedEtapeIds.length > 0) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/supprimer-etape-pour-utilisateurs/`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            selectedEtapeIds: selectedEtapeIds,
                            user_id: user_id,
                        }),
                    }
                );
                const data = await response.json();

                if (response.ok) {
                    // setEtape(etape.filter((etape) => etape.id !== selectedEtape.id));
                    fetchEtapeData()
                    setSelectedEtape(null);
                    setConfirmerSuppressionEtapeModal(false);
                    showAlert("Etape supprimé avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de l\'etape', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        }
    };

    const handlefichier = async (fichier, etapeId, module) => {
        if (!fichier) {
            showAlert("Veuillez sélectionner un fichier à importer.");
            return;
        }

        // Vérification du module, l'importation est autorisée uniquement pour "Cours" ou "Ressources"
        if (module !== "Cours" && module !== "Ressources") {
            showAlert("L'importation de fichiers n'est autorisée que pour les modules de type 'Cours' ou 'Ressources'.");
            return;
        }

        console.log("Fichier sélectionné:", fichier);

        try {
            setIsImporting(true);
            setProgress(0);

            // Affichage d'un message pendant l'importation
            showAlert("Importation en cours...");

            // Simuler une progression (optionnel)
            const progressInterval = setInterval(() => {
                setProgress(prev => {
                    if (prev >= 90) {
                        clearInterval(progressInterval);
                        return 90;
                    }
                    return prev + 10;
                });
            }, 200);

            // Préparer les données à envoyer
            const formData = new FormData();
            formData.append("fichier", fichier);
            formData.append("etape_id", etapeId);

            // Effectuer la requête POST pour importer le fichier
            const response = await fetch(`${process.env.REACT_APP_HOTE}/importer-fichier/${etapeId}/${user_id}/`, {
                method: "POST",
                body: formData,
            });

            clearInterval(progressInterval);
            setProgress(100);

            if (response.ok) {
                const data = await response.json();
                console.log("Importation réussie:", data);
                showAlert("Fichier importé avec succès !");
                fetchEtapeData();
                setShowImportModal(false);
                setSelectedFile(null);
            } else {
                const errorData = await response.json();
                console.error("Erreur lors de l'importation:", errorData);
                showAlert("Échec de l'importation. Vérifiez le fichier ou réessayez.");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Erreur réseau. Veuillez réessayer.");
        } finally {
            setIsImporting(false);
            setProgress(0);
        }
    };

    const handleDownload = (etapeId) => {
        if (!etapeId) {
            showAlert("Aucun fichier à télécharger.");
            return;
        }

        // Construire l'URL pour le téléchargement
        const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger_fichier/${etapeId}/${user_id}/`;
        //window.location.href = downloadUrl;

        // Utiliser `fetch` pour vérifier si l'URL est valide
        fetch(downloadUrl, {
            method: "GET",
        })
            .then((response) => {
                if (response.ok) {
                    // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
                    window.location.href = downloadUrl;
                } else {
                    showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
                }
            })
            .catch((error) => {
                console.error("Erreur lors du téléchargement :", error);
                showAlert("Une erreur s'est produite lors du téléchargement.");
            });
    };




    const [selectedEtapeIds, setSelectedEtapeIds] = useState([]);

    const handleCheckboxChange = (id) => {
        setSelectedEtapeIds((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        );
    };


    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Parcours")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }




    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaChartLine size={25} className="mr-2" />
                                Gestion des étapes du parcours
                            </h2>
                            <small>Visualisez les étapes associées à ce parcours.</small>
                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/Liste-parcours`}>Parcours</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/Liste-parcours`}>{parcours_titre}</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Etapes</li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {/* Liste des semaines */}
                    <div className="mt-3">
                        <div className='wrapper wrapper-content animated fadeInRight'>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des etapes du parcours</h5>
                                <div className='d-flex'>
                                    <button
                                        onClick={handleConfigurationdModal}
                                        className={`btn ms-2 mr-2 mt-1 d-flex justify-center align-items-center btn-success`}
                                    >
                                        <i className="fa fa-plus mr-1" style={{ fontSize: '1rem' }}></i>
                                        <span className="d-none d-sm-inline">
                                            Ajouter
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleModifEtapeModal}
                                        className={`btn ms-2 mr-2 mt-1 d-flex justify-center align-items-center ${selectedEtape ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEtape}
                                    >
                                        <i className="fa fa-edit mr-1" style={{ fontSize: '1rem' }}></i>
                                        <span className="d-none d-sm-inline">
                                            Modifier etape
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleConfirmerSuppressionEtapeModal}
                                        className={`btn d-flex align-items-center justify-content-center mr-2 ms-2 mt-1 ${selectedEtapeIds.length < 1 ? 'btn-default text-dark ' : 'btn-success'}`}
                                        disabled={selectedEtapeIds.length < 1}
                                    >
                                        <i className="fa fa-trash mr-1" style={{ fontSize: '1rem' }}></i>
                                        <span className="d-none d-sm-inline">
                                            Supprimer etape
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowImportModal}
                                        className={`btn ms-2 mr-2 mt-1 d-flex justify-center align-items-center ${selectedEtape && (selectedEtape.module === 'Cours' || selectedEtape.module === 'Ressources') ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEtape || !(selectedEtape.module === 'Cours' || selectedEtape.module === 'Ressources')}
                                    >
                                        <FaFileImport className='mr-1' />
                                        <span className="d-none d-sm-inline">
                                            Importer fichier
                                        </span>
                                    </button>

                                    {/* <button
                                        className={`btn ms-2 mt-1 d-flex justify-center align-items-center ${selectedEtape ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEtape}
                                    >
                                        <i className="fa fa-trash mr-1" style={{ fontSize: '1rem' }}></i>Supprimer
                                    </button> */}
                                </div>

                            </div>

                            {/* Modal pour ajouter une étape */}
                            <Modal show={configurationdModal} onHide={handleFermerConfigurationModal}>
                                <Modal.Header>
                                    <Modal.Title>Ajouter une étape</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-2 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    <Form>
                                        {/* NUMERO de l'étape */}
                                        {/* <Form.Group className="mb-3">
                                            <Form.Label>Ordre</Form.Label>
                                            <Form.Control
                                                type="number"
                                                required
                                                value={etape.numero || (Math.max(...(listeEtape?.map(e => e.numero) || [0])) + 1)}
                                                onChange={(event) => setEtape({ ...etape, numero: event.target.value })}
                                            />
                                        </Form.Group> */}
                                        {/* NUMERO de l'étape */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ordre</Form.Label>
                                            <Form.Control
                                                type="number"
                                                required
                                                value={etape.numero || (listeEtape?.length > 0
                                                    ? Math.max(...listeEtape.map(e => e.numero)) + 1
                                                    : 1)}
                                                onChange={(event) => setEtape({ ...etape, numero: event.target.value })}
                                            />
                                        </Form.Group>


                                        {/* Titre de l'étape */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Titre de l'étape</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={etape.titre || ""}
                                                onChange={(event) => setEtape({ ...etape, titre: event.target.value })}
                                            />
                                        </Form.Group>

                                        {/* Nom du coach */}
                                        {/* <Form.Group className="mb-3">
                                            <Form.Label>Nom du coach</Form.Label>
                                            <Form.Control
                                                type="text"
                                                required
                                                value={etape.coach || ""}
                                                onChange={(event) => setEtape({ ...etape, coach: event.target.value })}
                                            />
                                        </Form.Group> */}


                                        <Form.Group className="mb-3">
                                            <Form.Label>Lien URL (optionnel)</Form.Label>
                                            <Form.Control
                                                type="url"
                                                placeholder="https://example.com"
                                                value={etape.lien_url || ""}
                                                onChange={(event) => setEtape({ ...etape, lien_url: event.target.value })}
                                            />
                                        </Form.Group>

                                        {/* <Form.Group className="mb-3">
                                            <Form.Label>Niveau</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder=""
                                                value={etape.niveau || ""}
                                                onChange={(event) => setEtape({ ...etape, niveau: event.target.value })}
                                            />
                                        </Form.Group> */}

                                        <Form.Group className="mb-3">
                                            <Form.Label>Code couleur</Form.Label>
                                            <div className="d-flex align-items-center mb-3">
                                                {/* Aperçu de la couleur */}
                                                <div
                                                    style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        backgroundColor: etape.code_couleur || '#62fe2b',
                                                        border: '1px solid #ddd',
                                                        marginRight: '10px'
                                                    }}
                                                />
                                                {/* Champ texte */}
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Code couleur"
                                                    value={etape.code_couleur || ""}
                                                    onChange={(e) => setEtape({ ...etape, code_couleur: e.target.value })}
                                                // style={{ maxWidth: '100px' }}
                                                />
                                            </div>

                                            {/* Sélecteur de couleur */}
                                            <HexColorPicker
                                                color={etape.code_couleur || '#62fe2b'}
                                                onChange={(color) => setEtape({ ...etape, code_couleur: color })}
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Group>

                                        {/* Module de l'étape */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Module</Form.Label>
                                            <select
                                                className="form-control"
                                                required
                                                value={etape.module || ""}
                                                onChange={(event) => setEtape({ ...etape, module: event.target.value })}
                                            >
                                                <option value="">Choisissez un module</option>
                                                <option value="Revision">Revision</option>
                                                <option value="Eligibilite">Eligibilite</option>
                                                <option value="Cours">Cours</option>
                                                <option value="Evaluation">Evaluation</option>
                                                <option value="Ressources">Ressources</option>
                                                <option value="Avis_client">Avis client</option>
                                                <option value="Etude_de_cas">Etude de cas</option>
                                                <option value="Autre">Autre</option>
                                            </select>
                                        </Form.Group>

                                        {(etape.module === "Autre") && (
                                            <Form.Group className="mb-3">
                                                <Form.Label>Autre</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={etape.autre || ""}
                                                    onChange={(event) => setEtape({ ...etape, autre: event.target.value })}
                                                />
                                            </Form.Group>
                                        )}

                                        {/* Condition pour les tags si le module est "Evaluation" */}
                                        {(etape.module === "Evaluation") && (
                                            <>
                                                <Form.Group className="mb-3">
                                                    <label>Tags</label>
                                                    <Select
                                                        isMulti
                                                        options={tags.map((tag) => ({
                                                            value: tag.titre,
                                                            label: tag.titre,
                                                        }))}
                                                        value={etape.tags?.map((tag) => ({
                                                            value: tag,
                                                            label: tag,
                                                        }))}
                                                        onChange={(selectedOptions) => {
                                                            const selectedTags = selectedOptions.map((option) => option.value);
                                                            setEtape({ ...etape, tags: selectedTags });
                                                        }}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Sélectionnez un ou plusieurs tags..."

                                                        styles={{
                                                            multiValue: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#0d6efd", // bg-primary color
                                                                color: "white",
                                                                borderRadius: "5px",
                                                                padding: "2px 5px",
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                            }),
                                                            multiValueRemove: (base) => ({
                                                                ...base,
                                                                color: "white",
                                                                ':hover': {
                                                                    backgroundColor: "#0b5ed7", // Darker blue for hover effect
                                                                    color: "white",
                                                                }
                                                            })
                                                        }}
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Type d'évaluation</Form.Label>
                                                    <select
                                                        className="form-control"
                                                        required
                                                        value={etape.type_evaluation || ""}
                                                        onChange={(event) => setEtape({ ...etape, type_evaluation: event.target.value })}
                                                    >
                                                        <option value="">Choisissez le type de l'évaluation</option>
                                                        <option value="pre">Pré</option>
                                                        <option value="post">Post</option>
                                                        <option value="autre">Autre</option>
                                                    </select>
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nombre qcm</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        required
                                                        value={etape.nombre_qcm}
                                                        onChange={(event) => setEtape({ ...etape, nombre_qcm: event.target.value })}
                                                    />
                                                </Form.Group>
                                            </>
                                        )}

                                        {/* Date d'échéance */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date d'échéance</Form.Label>
                                            <Form.Control
                                                type="date"
                                                required
                                                value={etape.date_echeance?.split('/').reverse().join('-') || ""}
                                                min={new Date().toISOString().split('T')[0]} // Date actuelle au format ISO (YYYY-MM-DD)
                                                onChange={(event) => {
                                                    const dateIso = event.target.value; // Format ISO (YYYY-MM-DD)
                                                    const [year, month, day] = dateIso.split('-');
                                                    const dateFr = `${day}/${month}/${year}`; // Format FR (DD/MM/YYYY)

                                                    setEtape({ ...etape, date_echeance: dateFr });
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Etape précédente</Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                required
                                                value={etape.etapePrec || ""}
                                                onChange={(event) => setEtape({ ...etape, etapePrec: event.target.value })}
                                            >
                                                <option value="">...</option>
                                                {listeEtape.map((listeEtape) => (
                                                    <option key={listeEtape.id} value={listeEtape.id}>
                                                        {listeEtape.titre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Noification</Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                required
                                                value={etape.notification || ""}
                                                onChange={(event) => setEtape({ ...etape, notification: event.target.value })}
                                            >
                                                <option value="">Choisir une notification</option>
                                                {notifications.map((notification) => (
                                                    <option key={notification.id} value={notification.id}>
                                                        {notification.titre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>


                                        {/* Section des boutons */}
                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                variant="secondary"
                                                className="me-2 mr-2"
                                                onClick={handleFermerConfigurationModal}
                                            >
                                                Annuler
                                            </Button>
                                            <Button
                                                variant="success"
                                                onClick={() => handleEnregEtape(etape)}
                                                disabled={isLoadingAjout}
                                            >
                                                {isLoadingAjout ? "Chargement" : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Form>
                                </Modal.Body>
                            </Modal>

                            {/* Modal pour modifier une étape */}
                            <Modal show={modifEtapeModal} onHide={() => setModifEtapeModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Modifier l'Étape</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-2 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    {/* Vérifiez si une étape est sélectionnée */}
                                    {selectedEtape ? (
                                        <div>
                                            {/* NUMERO de l'étape */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ordre</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    required
                                                    value={selectedEtape.numero || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, numero: event.target.value })}
                                                />
                                            </Form.Group>

                                            {/* Titre de l'étape */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Titre</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={selectedEtape.titre || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, titre: event.target.value })}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Lien URL (optionnel)</Form.Label>
                                                <Form.Control
                                                    type="url"
                                                    placeholder="https://example.com"
                                                    value={selectedEtape.lien_url || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, lien_url: event.target.value })}
                                                />
                                            </Form.Group>

                                            {/* <Form.Group className="mb-3">
                                                <Form.Label>Niveau</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    value={selectedEtape.niveau || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, niveau: event.target.value })}
                                                />
                                            </Form.Group> */}

                                            <Form.Group className="mb-3">
                                                <Form.Label>Code couleur</Form.Label>
                                                <div className="d-flex align-items-center mb-3">
                                                    <div
                                                        style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            backgroundColor: selectedEtape?.code_couleur || '#62fe2b',
                                                            border: '1px solid #ddd',
                                                            marginRight: '10px'
                                                        }}
                                                    />
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Code couleur"
                                                        value={selectedEtape?.code_couleur || ""}
                                                        onChange={(e) => setSelectedEtape({ ...selectedEtape, code_couleur: e.target.value })}
                                                        style={{ maxWidth: '100px' }}
                                                    />
                                                </div>

                                                <HexColorPicker
                                                    color={selectedEtape?.code_couleur || '#62fe2b'}
                                                    onChange={(color) => setSelectedEtape({ ...selectedEtape, code_couleur: color })}
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Group>

                                            {/* Module */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Module</Form.Label>
                                                <select
                                                    className="form-control"
                                                    required
                                                    value={selectedEtape.module || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, module: event.target.value })}
                                                >
                                                    <option value="">Choisissez un module</option>
                                                    <option value="Revision">Revision</option>
                                                    <option value="Eligibilite">Eligibilite</option>
                                                    <option value="Cours">Cours</option>
                                                    <option value="Evaluation">Evaluation</option>
                                                    <option value="Ressources">Ressources</option>
                                                    <option value="Avis_client">Avis client</option>
                                                    <option value="Etude_de_cas">Etude de cas</option>
                                                    <option value="Autre">Autre</option>
                                                </select>
                                            </Form.Group>

                                            {/* Liste des tags conditionnelle */}
                                            {(selectedEtape.module === "Evaluation") && (
                                                <>
                                                    <Form.Group className="mb-3">
                                                        <label>Tags</label>
                                                        <Select
                                                            isMulti
                                                            options={tags.map((tag) => ({
                                                                value: tag.titre,
                                                                label: tag.titre,
                                                            }))}
                                                            value={selectedEtape.tags?.map((tag) => ({
                                                                value: tag,
                                                                label: tag,
                                                            }))}
                                                            onChange={(selectedOptions) => {
                                                                const selectedTags = selectedOptions.map((option) => option.value);
                                                                setSelectedEtape({ ...selectedEtape, tags: selectedTags });
                                                            }}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            placeholder="Sélectionnez un ou plusieurs tags..."

                                                            styles={{
                                                                multiValue: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: "#0b5ed7", // bg-primary color
                                                                    color: "white",
                                                                    borderRadius: "5px",
                                                                    // padding: "2px 5px",
                                                                }),
                                                                multiValueLabel: (base) => ({
                                                                    ...base,
                                                                    color: "white",
                                                                }),
                                                                multiValueRemove: (base) => ({
                                                                    ...base,
                                                                    color: "white",
                                                                    ':hover': {
                                                                        backgroundColor: "#0b5ed7",
                                                                        color: "white",
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Type d'évaluation</Form.Label>
                                                        <select
                                                            className="form-control"
                                                            required
                                                            value={selectedEtape.type_evaluation || ""}
                                                            onChange={(event) => setSelectedEtape({ ...selectedEtape, type_evaluation: event.target.value })}
                                                        >
                                                            <option value="">Choisissez le type de l'évaluation</option>
                                                            <option value="pre">Pré</option>
                                                            <option value="post">Post</option>
                                                            <option value="autre">Autre</option>
                                                        </select>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nombre qcm</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            required
                                                            value={selectedEtape.nombre_qcm}
                                                            onChange={(event) => setSelectedEtape({ ...selectedEtape, nombre_qcm: event.target.value })}
                                                        />
                                                    </Form.Group>
                                                </>
                                            )}

                                            {(selectedEtape.module === "Autre") && (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Autre</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        required
                                                        value={selectedEtape.autre || ""}
                                                        onChange={(event) => setSelectedEtape({ ...selectedEtape, autre: event.target.value })}
                                                    />
                                                </Form.Group>
                                            )}


                                            {/* Date d'échéance */}
                                            <Form.Group className="mb-3">
                                                <Form.Label>Date d'échéance</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    required
                                                    value={selectedEtape.date_echeance?.split('/').reverse().join('-') || ""}
                                                    min={new Date().toISOString().split('T')[0]} // Date actuelle au format ISO (YYYY-MM-DD)
                                                    onChange={(event) => {
                                                        const dateIso = event.target.value; // Format ISO (YYYY-MM-DD)
                                                        const [year, month, day] = dateIso.split('-');
                                                        const dateFr = `${day}/${month}/${year}`; // Format FR (DD/MM/YYYY)

                                                        setSelectedEtape({ ...selectedEtape, date_echeance: dateFr });
                                                    }}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Etape précédente</Form.Label>
                                                <Form.Select
                                                    className="form-control"
                                                    required
                                                    value={selectedEtape.etapePrec}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, etapePrec: event.target.value })}
                                                >
                                                    <option value="">Choisir une étape</option>
                                                    {listeEtape.map((listeEtape) => (
                                                        <option key={listeEtape.id} value={listeEtape.id}>
                                                            {listeEtape.titre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Noification</Form.Label>
                                                <Form.Select
                                                    className="form-control"
                                                    required
                                                    value={selectedEtape.notification || ""}
                                                    onChange={(event) => setSelectedEtape({ ...selectedEtape, notification: event.target.value })}
                                                >
                                                    <option value="">Choisir une notification</option>
                                                    {notifications.map((notification) => (
                                                        <option key={notification.id} value={notification.id}>
                                                            {notification.titre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    ) : (
                                        <p>Aucune étape sélectionnée.</p>
                                    )}

                                    {/* Section des boutons */}
                                    <div className="d-flex justify-content-end mt-4">
                                        <Button variant="secondary" className="me-2 mr-2" onClick={() => setModifEtapeModal(false)}>
                                            Annuler
                                        </Button>
                                        <Button
                                            variant="success"
                                            onClick={handleEnregModifEtapePartout}
                                            disabled={isLoadingModification}
                                        >
                                            {isLoadingModification ? "Chargement" : "Modifier"}
                                        </Button>
                                    </div>
                                </Modal.Body>
                            </Modal>

                            {/* Modal de l'importation */}
                            <Modal show={showImportModal} onHide={handleCloseImportModal}>
                                <Modal.Header>
                                    <Modal.Title>Importation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group controlId="formFile" className="mt-3">
                                        <Form.Label>Choisissez un fichier à importer</Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleFileChange}
                                        />
                                    </Form.Group>
                                    {isImporting && (
                                        <div className="mt-3">
                                            <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseImportModal}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={() => handlefichier(selectedFile, selectedEtape?.id, selectedEtape?.module)}
                                        disabled={!selectedFile || isImporting}
                                    >
                                        {isImporting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Importation...
                                            </>
                                        ) : (
                                            <>
                                                <FaFileImport className="mr-1" />
                                                Importer
                                            </>
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                            <Modal show={confirmerSuppressionEtapeModal} onHide={handleFermerConfirmerSuppressionEtapeModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer la suppression</Modal.Title>
                                </Modal.Header>
                                {alertModal.message && (
                                    <div className={`m-2 alert alert-${alertModal.type}`}>
                                        {alertModal.message}
                                    </div>
                                )}
                                <Modal.Body>
                                    Etes-vous sûr de vouloir supprimer cette étape ?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleFermerConfirmerSuppressionEtapeModal}>
                                        Annuler
                                    </Button>
                                    {/* <Button variant="success" onClick={handleSupprimerEtape}>
                                        Non
                                    </Button> */}
                                    <Button variant="success" onClick={handleSupprimerEtapePartout}>
                                        Confirmer
                                    </Button>
                                </Modal.Footer>
                            </Modal>


                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>

                                            <DragDropContext onDragEnd={handleDragEnd}>
                                                <Droppable droppableId="etapes">
                                                    {(provided, snapshot) => (
                                                        <div
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}
                                                            className={`droppable-area ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
                                                        >
                                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                                <thead>
                                                                    <tr>
                                                                        <th></th>
                                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('numero')}>
                                                                            Ordre {sortConfig.key === 'numero'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                        </th>
                                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('titre')}>
                                                                            Etape {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                        </th>
                                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('date_echeance')}>
                                                                            Echéance {sortConfig.key === 'date_echeance'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                        </th>
                                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('module')}>
                                                                Module {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th> */}
                                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('coach')}>
                                                                Coach {sortConfig.key === 'coach'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th> */}
                                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('module')}>
                                                                            Module {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                        </th>
                                                                        <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('type_evaluation')}>
                                                                            Type d'évaluation {sortConfig.key === 'type_evaluation'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                                        </th>
                                                                        {/* <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('fichier')}>
                                                                Fichier {sortConfig.key === 'fichier'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {!isLoadingGlobale ? (
                                                                        currentEtape.length > 0 ? (
                                                                            currentEtape.map((item, index) => (
                                                                                <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                                                                                    {(provided, snapshot) => (
                                                                                        <tr
                                                                                            ref={provided.innerRef}
                                                                                            {...provided.draggableProps}
                                                                                            {...provided.dragHandleProps}
                                                                                            onClick={() => setSelectedEtape(item)}
                                                                                            style={{
                                                                                                ...provided.draggableProps.style,
                                                                                                cursor: 'grab',
                                                                                                backgroundColor: snapshot.isDragging
                                                                                                    ? 'rgba(0, 123, 255, 0.1)'
                                                                                                    : item.code_couleur || 'transparent',
                                                                                                color: getTextColor(item.code_couleur),
                                                                                                border: snapshot.isDragging ? '1px dashed #007bff' : '1px solid transparent',
                                                                                                boxShadow: snapshot.isDragging ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none',
                                                                                                opacity: snapshot.isDragging ? 0.8 : 1,
                                                                                                transition: 'all 0.3s ease',
                                                                                            }}
                                                                                            className={`cursor-pointer ${selectedEtape?.id === item.id ? 'bg-success text-white' : ''}`}
                                                                                        >
                                                                                            <td>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="i-checks"
                                                                                                    name="input[]"
                                                                                                    checked={selectedEtapeIds.includes(item.id)}
                                                                                                    onChange={() => handleCheckboxChange(item.id)}
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                {item.numero}
                                                                                                <div className='lesInfos'>
                                                                                                    <small>Etape : {item.titre}
                                                                                                        {item.lien_url && (
                                                                                                            <a
                                                                                                                href={item.lien_url}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                style={{ marginLeft: "8px", color: "blue" }}
                                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                                            >
                                                                                                                <i className="fa fa-play-circle-o" title="Ouvrir le lien"></i>
                                                                                                                <FaRegPlayCircle size={15} />
                                                                                                            </a>
                                                                                                        )}</small><br />
                                                                                                    <small>Echéance : {item.date_echeance}</small><br />
                                                                                                    <small>Module :
                                                                                                        {/* Affichage de l'icône si le module est "Cours" et qu'un fichier existe */}
                                                                                                        {item.module}
                                                                                                        {(item.module === "Cours" || item.module === "Ressources") && item.fichier && (
                                                                                                            <span
                                                                                                                //className="download-icon"
                                                                                                                onClick={() => handleDownload(item.id)} // Fonction pour voir ou télécharger le fichier
                                                                                                                style={{ cursor: "pointer", marginLeft: "8px", color: "blue" }} // Style pour rendre l'icône cliquable
                                                                                                            >
                                                                                                                <i className="fa fa-download" title="Voir le fichier"></i>
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </small>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className="d-none d-md-table-cell">
                                                                                                {item.titre}
                                                                                                {item.lien_url && (
                                                                                                    <a
                                                                                                        href={item.lien_url}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        style={{ marginLeft: "8px", color: "blue" }}
                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                    >
                                                                                                        <FaRegPlayCircle size={15} />
                                                                                                    </a>
                                                                                                )}
                                                                                            </td>
                                                                                            <td className="d-none d-md-table-cell">{item.date_echeance}</td>
                                                                                            {/* <td>{item.coach}</td> */}
                                                                                            <td className="d-none d-md-table-cell">
                                                                                                {/* Affichage de l'icône si le module est "Cours" et qu'un fichier existe */}
                                                                                                {item.module === 'Avis_client' ? 'Avis client' : item.module}
                                                                                                {(item.module === "Cours" || item.module === "Ressources") && item.fichier && (
                                                                                                    <span
                                                                                                        //className="download-icon"
                                                                                                        onClick={() => handleDownload(item.id)} // Fonction pour voir ou télécharger le fichier
                                                                                                        style={{ cursor: "pointer", marginLeft: "8px", color: "blue" }} // Style pour rendre l'icône cliquable
                                                                                                    >
                                                                                                        <i className="fa fa-download" title="Voir le fichier"></i>
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>

                                                                                            <td>
                                                                                                {item.type_evaluation === 'pre' && 'Pré-test'}
                                                                                                {item.type_evaluation === 'post' && 'Post-test'}
                                                                                                {item.type_evaluation === 'autre' && 'Autre'}
                                                                                            </td>
                                                                                            {/* <td>{item.fichier}</td> */}
                                                                                        </tr>
                                                                                    )}
                                                                                </Draggable>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="4">Aucune etape trouvée</td>
                                                                            </tr>
                                                                        )
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5">
                                                                                <div className="d-flex justify-content-center align-items-center py-4">
                                                                                    <div className="spiner-example">
                                                                                        <div className="sk-spinner sk-spinner-wave">
                                                                                            <div className="sk-rect1 mr-1"></div>
                                                                                            <div className="sk-rect2 mr-1"></div>
                                                                                            <div className="sk-rect3 mr-1"></div>
                                                                                            <div className="sk-rect4 mr-1"></div>
                                                                                            <div className="sk-rect5"></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {provided.placeholder}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>


                                            {/* Pagination */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {filteredEtapes.length === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstEtape + 1} à ${Math.min(indexOfLastEtape, filteredEtapes.length)} sur ${filteredEtapes.length}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                        <button
                                                            key={page}
                                                            onClick={() => setCurrentPage(page)}
                                                            className={`btn ${currentPage === page ? 'btn-default' : 'btn-light'} mx-1`}
                                                        >
                                                            {page}
                                                        </button>
                                                    ))}
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Configuration_parcours;
